import React from 'react';
import PropTypes from 'prop-types';

function ChevronRight({ size = 20, color, style }) {
  return (
    <svg width={size} height={size} style={style} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path className={`icon-chevron-right`} d="M6 16L12 10L6 4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

ChevronRight.propTypes = {
  color: PropTypes.string.isRequired,
  size: PropTypes.number
}

export default ChevronRight;
